export default function EditTopThreatsByProcessDialogController(
  $filter,
  $rootScope,
  $q,
  $timeout,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.activeProcess = vm.processes[0];

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleNavToProcess = _handleNavToProcess;
  vm.handleFormSubmit = _handleFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editTopThreatsByProcessDialog);
  }

  function _handleNavToProcess(processId) {
    const newActiveProcess = $filter(
      'filter'
    )(
      vm.processes,
      {
        processId,
      },
      true
    )[0];
    if (vm.activeProcess !== newActiveProcess) {
      vm.contentPaneIsFaded = true;
      $timeout(
        () => {
          vm.activeProcess = newActiveProcess;
          vm.contentPaneIsFaded = false;
        },
        100
      );
    }
  }

  function _saveProcessThreats() {
    return bcpDataService.saveAssessmentProcessThreats(vm.assessmentId, vm.processes);
  }

  function _handleFormSubmit() {
    _saveProcessThreats().then(() => {
      alerts.success('The BCP Top Threats by Process have been saved successfully.');
      $rootScope.$broadcast('refreshBCPAssessments');
      $rootScope.$broadcast('refreshNotifications');

      if (vm.saveType === 'saveAndClose') {
        ssDialogService.hide(ssDialogService.dialogs.bcp.editTopThreatsByProcessDialog);
      }
    });
  }
}

EditTopThreatsByProcessDialogController.$inject = [
  '$filter',
  '$rootScope',
  '$q',
  '$timeout',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
